module.exports = __webpack_public_path__ + "static/media/trash.dbd0c449.svg";